import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "h-h",
  components: {// tuiEditor
  },
  props: {
    isBook: {
      type: Boolean,
      default: true
    },
    queTitle: {
      type: String,
      default: ""
    },
    queFaceId: {
      type: String,
      default: ""
    },
    questionnaireId: {
      type: String,
      default: ""
    },
    queId: {
      type: String,
      default: ""
    },
    quesType: {
      type: Number,
      default: 1
    },
    quesOrder: {
      type: Number,
      default: 1
    },
    isquestion: {
      type: Boolean,
      default: true
    },
    courseId: {
      type: String,
      default: ""
    },
    iSubmit: {
      type: Boolean,
      default: false
    },
    li: {
      type: Object,
      default: {
        questionId: "",
        ContentText: "",
        dataJson: [{
          Content: ""
        }, {
          Content: ""
        }, {
          Content: ""
        }, {
          Content: ""
        }],
        questionType: 1,
        sortOrder: 1
      }
    },
    questionIndex: {
      type: Number,
      default: 999
    },
    isdShow: {
      type: [String, Boolean],
      default: ''
    }
  },
  created: function created() {
    this.thisContent = this.queTitle;

    if (this.isdShow) {
      this.isShow = JSON.parse(this.isdShow);
    }
  },
  data: function data() {
    return {
      content: "请输入内容",
      alphabet: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      thisContent: "",
      isShow: false
    };
  },
  watch: {
    iSubmit: function iSubmit(val) {
      if (val) {
        //this.saveQuestion(1);
        this.checkSubmit();
      }
    },
    queTitle: function queTitle(val) {
      this.thisContent = this.queTitle;
    }
  },
  methods: {
    // 添加选项
    addChoice: function addChoice() {
      var n = this.li.dataJson.length;

      if (n >= 26) {
        this.$message("您最多可添加26个选项哦");
        return;
      }

      var str = {
        Content: ""
      };
      this.li.dataJson.push(str);
    },
    // 删除选项
    closeChoice: function closeChoice(index) {
      this.li.dataJson.splice(index, 1);
    },
    checkSubmit: function checkSubmit() {
      if (this.li.ContentText == "") {
        this.$emit("submit", {
          code: 0,
          count: 1,
          msg: "第" + this.li.sortOrder + "题标题为空"
        });
        return;
      }

      var right = true;

      for (var i = 0; i < this.li.dataJson.length; i++) {
        if (this.li.dataJson[i].Content == "") {
          this.$emit("submit", {
            code: 0,
            count: 1,
            msg: "第" + this.li.sortOrder + "题选项为空"
          });
          right = false;
          break;
        }
      }

      if (right) {
        this.$emit("submit", {
          code: 1,
          count: 1,
          msg: "success"
        });
      }
    },
    saveQuestion: function saveQuestion(type) {
      //type 1 由父页面发送指令统一提交保存
      //type 2 由子页面独立提交保存
      var title = this.queTitle;
      var stringJson = JSON.stringify(this.dataJson);
      var activityId = this.queFaceId;
      var questionnaireId = this.questionnaireId;
      var questionId = this.queId;
      var quesType = this.quesType;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/addQuestionnaireDetail", {
        questionnaireId: questionnaireId,
        questionId: questionId,
        title: title,
        dataJson: stringJson,
        answer: "",
        questionType: this.quesType,
        sortOrder: this.quesOrder
      }).then(function (rst) {
        if (rst.code > 0) {
          //独立提交时，触发父页面刷新事件；统一提交时，触发done事件：统计成功个数
          if (type == 1) {
            that.$emit("done", {
              code: 1
            });
          } else {
            that.$emit("updatePage", {});
          }
        } else {
          that.$message(rst.msg);
        }
      });
    },
    saveQuestionSingle: function saveQuestionSingle() {
      //每一小题独立提交保存
      var title = this.queTitle;
      var stringJson = JSON.stringify(this.dataJson);
      var activityId = this.queFaceId;
      var questionnaireId = this.questionnaireId;
      var questionId = this.queId;
      var quesType = this.quesType;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/saveCourseQuest", {
        courseId: that.courseId,
        courseOpenId: that.courseOpenId,
        questionnaireId: questionnaireId,
        questionId: questionId,
        title: title,
        dataJson: stringJson,
        answer: "",
        questionType: questionType
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$emit("updatePage", {});
        }

        that.$message(rst.msg);
      });
    },
    save: function save() {
      if (this.queFaceId == "" || this.queFaceId == null) {
        this.saveQuestionSingle();
      } else {
        this.saveQuestion(2);
      }
    }
  },
  mounted: function mounted() {
    var path = this.$route.path;

    if (path.indexOf('ShareSurveyCourseView') != -1) {
      this.isShow = true;
    }
  }
};